@if (chartShow) {
  <dx-select-box
    #chartTypeSelector
    [items]="chartTypes"
    displayExpr="name"
    valueExpr="value"
    [value]="chartDefault"
    [width]="220"
  ></dx-select-box>
  <dx-chart (onPointClick)="expandSelected($event)">
    <dxo-common-series-settings [type]="chartTypeSelector.value"></dxo-common-series-settings>
    <dxo-size [height]="500"></dxo-size>
    <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="right"></dxo-legend>
    <dxo-tooltip [enabled]="true" [format]="{}"></dxo-tooltip>
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-zoom-and-pan argumentAxis="both" [dragToZoom]="true"></dxo-zoom-and-pan>
    <dxo-scroll-bar [visible]="true"></dxo-scroll-bar>
  </dx-chart>
  <br/>
}

<div class="d-flex justify-content-between">
  <dx-tag-box
    [items]="distinctYearsItems"
    displayExpr="name"
    valueExpr="value"
    [(value)]="distinctYearValue"
    [showDropDownButton]="true"
    [showSelectionControls]="true"
    applyValueMode="useButtons"
    [maxDisplayedTags]="3"
    [showMultiTagOnly]="false"
    [multiline]="false"
    class="tag-box-padding"
    width="255px"
    (onValueChanged)="filterPivotGrid()"
  ></dx-tag-box>

  @if (this.isLoggedIn) {
    <div>
      <dx-radio-group
        [items]="publicTypes"
        displayExpr="name"
        valueExpr="value"
        [(value)]="public"
        layout="horizontal"
        (onValueChanged)="filterPublic(public)"
      ></dx-radio-group>
    </div>
  }
</div>

<!-- <dx-drop-down-button
*ngFor="let filterValue of filterValues"
class="dropDownButton"
[text]="filterValue.text!"
[items]="filterValue.items!"
[dropDownOptions]="{ width: 'auto' }"
>
<div *dxTemplate="let data of 'content'" class="m-2">
  <dx-tree-view
    *ngIf="data"
    [items]="filterValue.items!"
    dataStructure="plain"
    parentIdExpr="parentId"
    keyExpr="id"
    displayExpr="text"
    [focusStateEnabled]="false"
  ></dx-tree-view>
</div>
</dx-drop-down-button> -->

<dx-pivot-grid
  [allowFiltering]="true"
  [showBorders]="true"
  [showColumnTotals]="false"
  [showColumnGrandTotals]="false"
  [showRowGrandTotals]="false"
  [hideEmptySummaryCells]="true"
  [dataSource]="pivotGridDataSource"
  [texts]="{ total: '{0}' }"
  (onCellClick)="onCellClick($event)"
  (onCellPrepared)="onCellPrepared($event)"
  (onExporting)="onExporting($event)"
  [rowHeaderLayout]="treeHeaderLayout ? 'tree' : 'standard'"
  >
  <dxo-field-panel
    [visible]="true"
    [showColumnFields]="false"
    [showDataFields]="false"
    [showRowFields]="false"
    [texts]="{ filterFieldArea: '' }"
  ></dxo-field-panel>
  <dxo-header-filter [allowSearch]="true" [showRelevantValues]="true" ></dxo-header-filter>
  <dxo-field-chooser [enabled]="true" [allowSearch]="true" applyChangesMode="onDemand"></dxo-field-chooser>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-scrolling mode="virtual"></dxo-scrolling>
</dx-pivot-grid>
